import axios from "axios";
import { MarketAreaSettings } from "../Models/ApplicationModels";
import { useEffect, useRef } from "react";
import { useMarketAreaStore } from "../Store/userStore"; // adjust path

export const setMarketAreaHeader = (settings?: MarketAreaSettings) => {
  if (
    !settings ||
    settings.activeMarketArea === "" ||
    settings.userMode === undefined
  ) {
    delete axios.defaults.headers.common["Outotec-marketArea"];
    return false;
  }
  axios.defaults.headers.common[
    "Outotec-marketArea"
  ] = `${settings.activeMarketArea}:${settings.userMode}`;
  return true;
};

export function useBootstrapMarketArea(opts?: {
  subscribeToChanges?: boolean;
}) {
  const subscribeToChanges = opts?.subscribeToChanges ?? true;
  const didRunInitial = useRef(false);

  useEffect(() => {
    const apply = () => {
      const { marketAreaSettings } = useMarketAreaStore.getState();
      setMarketAreaHeader(marketAreaSettings);
    };

    // If already hydrated, apply immediately
    if (useMarketAreaStore.persist.hasHydrated()) {
      apply();
      didRunInitial.current = true;
    }

    // Also run when hydration finishes (first load)
    const unsubHydration = useMarketAreaStore.persist.onFinishHydration(() => {
      if (!didRunInitial.current) {
        apply();
        didRunInitial.current = true;
      }
    });

    return () => {
      unsubHydration?.();
    };
  }, [subscribeToChanges]);
}
